<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container pb-4 py-5">
          <div class="row justify-content-center">
            <div class="col-md-3 col-10 mb-md-0">
              <div class="dashboar-profile text-center position-relative mb-3">
                <div
                  id="ProfileSlider"
                  class="carousel slide profile-sider"
                  data-bs-ride="carousel"
                  data-bs-interval="false">
                  <div class="carousel-inner rounded-l" v-if="images.length">
                    <div
                      class="carousel-item"
                      v-for="(data, index) in images"
                      :key="index"
                      :class="index == 0 ? 'active' : ' '">
                      <div
                        class="member-profile-photo cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#photosModal">
                        <!-- <a
                            v-on:click="removeProfileImage(data.uuid)"
                            type="button"
                            class="close text-danger"
                          >
                            <img src="/images/close-btn.png" width="18" />
                          </a> -->
                        <img
                          :src="data.image ? data.image : '/img/profile.svg'"
                          class="profile-pics" />
                      </div>
                    </div>
                  </div>
                  <div
                    class="carousel-inner rounded-l"
                    v-if="images.length == 0">
                    <div class="carousel-item active">
                      <img src="/img/profile.svg" class="photos" />
                    </div>
                  </div>
                  <button
                    v-if="images.length"
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#ProfileSlider"
                    data-bs-slide="prev">
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    v-if="images.length"
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#ProfileSlider"
                    data-bs-slide="next">
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
                <!-- <div
                  class="text-center my-3 carousel-counter"
                  id="slide-counter"
                >
                  <div class="num text-white"></div>
                </div> -->
              </div>
              <!-- <div class="text-center">
                <p class="font-18 font-medium">
                  <span class="text-brand"
                    >{{ myDetails.profile_percentage }}%</span
                  >
                  Profile Completed
                </p>
                <div class="progress" style="height: 6px">
                  <div
                    class="progress-bar bg-brand"
                    role="progressbar"
                    :style="'width: ' + myDetails.profile_percentage + '%'"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div> -->
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-6 text-md-start text-center">
                  <p class="mb-0 text-brand font-14 font-medium">
                    {{ myDetails.registration_no }}
                  </p>
                  <h2
                    class="text-capitalize font-bold font-20"
                    style="word-break: break-all !important">
                    {{ myDetails.first_name }} {{ myDetails.middle_name }}
                    {{ myDetails.last_name }}
                  </h2>
                </div>
                <div
                  class="col-md-6 text-md-end text-center"
                  v-if="myDetails.membership_end_date">
                  <!-- Plan Valid till -->
                  <p class="mb-0 font-medium">Plan Valid till</p>
                  <p class="text-brand font-medium">
                    {{
                      myDetails.membership_end_date
                        ? $helperService.getFormatedDate(
                            myDetails.membership_end_date
                          )
                        : ""
                    }}
                  </p>
                </div>
              </div>
              <div class="row row-cols-2 row-cols-md-2 row-cols-lg-4">
                <div class="col">
                  <div
                    v-on:click="$router.push('/shortlisted')"
                    class="card card-body text-center bg-light user-record-card border-0 rounded-l mb-3">
                    <img
                      src="/images/shortlisted.svg"
                      width="35"
                      class="mx-auto mb-2" />
                    <h3 class="font-bold font-24 mb-0">
                      {{
                        counts.shortlisted_count
                          ? counts.shortlisted_count
                          : "0"
                      }}
                    </h3>
                    <p class="font-medium mb-0">Shortlisted</p>
                  </div>
                </div>
                <div class="col">
                  <div
                    v-on:click="$router.push('/intrest-sent')"
                    class="card card-body text-center bg-light border-0 rounded-l mb-3 user-record-card">
                    <img
                      src="/images/sent.svg"
                      width="35"
                      class="mx-auto mb-2" />
                    <h3 class="font-bold font-24 mb-0">
                      {{
                        counts.intrest_sent_count
                          ? counts.intrest_sent_count
                          : "0"
                      }}
                    </h3>
                    <p class="font-medium mb-0">Interest Sent</p>
                  </div>
                  <div class="detail-record text-center">
                    <p class="text-success">
                      Accepted-
                      {{
                        counts.accepted_sent_intrest_count
                          ? counts.accepted_sent_intrest_count
                          : "0"
                      }}
                    </p>
                    <p class="text-danger">
                      Rejected-
                      {{
                        counts.rejected_sent_intrest_count
                          ? counts.rejected_sent_intrest_count
                          : "0"
                      }}
                    </p>
                    <p class="text-warning mb-0">
                      Pending-
                      {{
                        counts.pending_sent_intrest_count
                          ? counts.pending_sent_intrest_count
                          : "0"
                      }}
                    </p>
                  </div>
                </div>
                <div class="col">
                  <div
                    v-on:click="$router.push('/intrest-recieved')"
                    class="card card-body text-center bg-light border-0 rounded-l mb-3 user-record-card">
                    <img
                      src="/images/recived.svg"
                      width="35"
                      class="mx-auto mb-2" />
                    <h3 class="font-bold font-24 mb-0">
                      {{
                        counts.intrest_recieved_count
                          ? counts.intrest_recieved_count
                          : "0"
                      }}
                    </h3>
                    <p class="font-medium mb-0">Interest Received</p>
                  </div>
                  <div class="detail-record text-center">
                    <p class="text-success">
                      Accepted-
                      {{
                        counts.accepted_recieved_intrest_count
                          ? counts.accepted_recieved_intrest_count
                          : "0"
                      }}
                    </p>
                    <p class="text-danger">
                      Rejected-
                      {{
                        counts.rejected_recieved_intrest_count
                          ? counts.rejected_recieved_intrest_count
                          : "0"
                      }}
                    </p>
                    <p class="text-warning mb-0">
                      Pending-
                      {{
                        counts.pending_recieved_intrest_count
                          ? counts.pending_recieved_intrest_count
                          : "0"
                      }}
                    </p>
                  </div>
                </div>
                <div class="col">
                  <div
                    v-on:click="$router.push('/contacts-viewed')"
                    class="card card-body text-center bg-light border-0 rounded-l user-record-card">
                    <img
                      src="/images/viewed.svg"
                      width="35"
                      class="mx-auto mb-1" />
                    <h3 class="font-bold font-24 mb-0">
                      {{
                        counts.viewed_contact_count
                          ? counts.viewed_contact_count
                          : "0"
                      }}
                    </h3>
                    <p class="font-medium mb-0">Viewed Contacts</p>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <router-link to="/my-profile" class="btn btn-brand-1 px-5"
                  >My Profile</router-link
                >
                <router-link
                  v-if="
                    this.myDetails.is_membership_subscribed == 'N' ||
                    this.myDetails.is_membership_subscribed == null
                  "
                  to="/membership-plans"
                  class="btn btn-brand-2 px-5 ms-3 margin15"
                  >View Membership</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bg-light py-2" v-if="membersCount > 0"></div>
        <div class="container pt-4" v-if="membersCount > 0">
          <div class="row mb-3">
            <div class="col-md-6">
              <h3 class="font-bold font-22" v-if="membersCount > 0">
                Newly Joined Members ({{ membersCount }})
              </h3>
            </div>
            <div class="col-md-6 text-md-end text-center">
              <a
                v-on:click="$router.push('/view-new-joined-member')"
                class="font-bold font-18"
                style="cursor: pointer"
                v-if="membersCount > 4"
                >View All
              </a>
            </div>
          </div>
          <div class="row">
            <div
              class="col-lg-6 mb-4"
              v-for="(data, index) in this.newJoinedmemberlist"
              :key="index"
              :value="data.uuid">
              <div
                v-if="index < 4"
                class="card card-body member-card mb-md-4 mb-3">
                <div class="row">
                  <div class="col-md-4 mb-md-0 mb-4 text-center">
                    <div
                      class="member-profile-photo cursor-pointer"
                      v-on:click="showUserGallery(data.user_images)">
                      <img
                        :src="data.image ? data.image : '/img/profile.svg'"
                        class="pro-pic" />
                      <span class="photos-count text-white"
                        ><i class="fa fa-camera" aria-hidden="true"></i>
                        <span class="ms-1">{{
                          data.user_images.length
                        }}</span></span
                      >
                    </div>
                    <button
                      v-if="data.hasSentIntrest == 0"
                      type="button"
                      class="btn btn-brand-1 mb-3 w-80"
                      :id="'sent_interest_' + index"
                      v-on:click="sendIntrest(data, index)">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send Interest
                    </button>
                    <button
                      v-if="data.hasSentIntrest == 1"
                      type="button"
                      class="btn btn-outline-brand-1"
                      :id="'cancel_interest_' + index"
                      v-on:click="notIntrested(data, index)">
                      <i class="fa fa-times" aria-hidden="true"></i>
                      Cancel Interest
                    </button>
                  </div>
                  <div
                    class="col-md-7 cursor-pointer"
                    v-on:click="$router.push('/profile-view/' + data.uuid)">
                    <p
                      class="font-medium"
                      style="cursor: pointer; font-size: 18px">
                      {{ data.registration_no }}
                    </p>
                    <p
                      :title="
                        getName(
                          data.first_name,
                          data.middle_name,
                          data.last_name
                        )
                      "
                      style="cursor: pointer"
                      class="font-bold text-uppercase pink-clr">
                      {{
                        $helperService.getText(
                          getName(
                            data.first_name,
                            data.middle_name,
                            data.last_name
                          ),
                          150
                        )
                      }}
                    </p>
                    <div class="d-flex">
                      <div class="w-50">
                        <p class="font-14 text-uppercase">
                          {{
                            data.marital_status
                              ? data.marital_status.name
                              : "NA"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.dob
                              ? $helperService.getFormatedDate(data.dob)
                              : "NA"
                          }}
                        </p>
                        <p
                          style="cursor: pointer"
                          class="font-14 font-semibold">
                          {{
                            data.height
                              ? $helperService.getHeight(data.height)
                              : "NA"
                          }}
                        </p>
                        <p
                          :title="
                            data.education_courses ? data.education_courses : ''
                          "
                          class="font-14 font-semibold">
                          {{
                            data.education_courses
                              ? $helperService.getText(
                                  data.education_courses,
                                  40
                                )
                              : "NA"
                          }}
                        </p>
                      </div>
                      <div class="w-50">
                        <p class="font-14 font-light">
                          {{
                            data.occupation_details
                              ? data.occupation_details
                              : "NA"
                          }}
                        </p>
                        <p class="font-semibold">
                          {{
                            data.annual_income || data.annual_income == 0
                              ? $helperService.kFormatter(data.annual_income)
                              : "-"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.working_place_taluka
                              ? data.working_place_taluka.name
                              : "NA"
                          }}
                        </p>
                        <!-- <p class="font-14 font-semibold">
                          Native :
                          {{
                            data.native_place_district
                              ? data.native_place_district.name
                              : "NA"
                          }}
                        </p> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ErrorComponent
            @retry="getNewJoinedMemberList(0)"
            ref="getNewJoinedMemberList" />
        </div>
        <div class="bg-light py-2" v-if="visitorsCount > 0"></div>
        <div class="container pt-4" v-if="visitorsCount > 0">
          <div class="row mb-3">
            <div class="col-md-6 row">
              <div>
                <h3 class="font-bold font-22" v-if="visitorsCount > 0">
                  Profile Visitors ({{ visitorsCount }})
                </h3>
              </div>
              <div>
                <h6
                  style="
                    font-weight: bold !important;
                    color: grey !important;
                    font-size: 12px !important;
                  ">
                  Note :These profiles might be interested in you
                </h6>
              </div>
            </div>
            <div class="col-md-6 text-md-end text-center">
              <a
                v-on:click="$router.push('/view-profile-visitors')"
                class="font-bold font-18"
                style="cursor: pointer"
                v-if="visitorsCount > 4"
                >View All
              </a>
            </div>
          </div>
          <div class="row">
            <div
              class="col-lg-6 mb-4"
              v-for="(data, index) in this.visitorslist"
              :key="index"
              :value="data.uuid">
              <div
                v-if="index < 4"
                class="card card-body member-card mb-md-4 mb-3">
                <div class="row">
                  <div class="col-md-4 mb-md-0 mb-4 text-center">
                    <div
                      class="member-profile-photo cursor-pointer"
                      v-on:click="showUserGallery(data.user_images)">
                      <img
                        :src="data.image ? data.image : '/img/profile.svg'"
                        class="pro-pic" />
                      <span class="photos-count text-white"
                        ><i class="fa fa-camera" aria-hidden="true"></i>
                        <span class="ms-1">{{
                          data.user_images.length
                        }}</span></span
                      >
                    </div>
                    <button
                      v-if="data.hasSentIntrest == 0"
                      type="button"
                      class="btn btn-brand-1 mb-3 w-80"
                      :id="'sent_interest_' + index"
                      v-on:click="sendIntrestForVisitor(data, index)">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send Interest
                    </button>
                    <button
                      v-if="data.hasSentIntrest == 1"
                      type="button"
                      class="btn btn-outline-brand-1"
                      :id="'cancel_interest_' + index"
                      v-on:click="notIntrestedForVisitor(data, index)">
                      <i class="fa fa-times" aria-hidden="true"></i>
                      Cancel Interest
                    </button>
                  </div>
                  <div
                    class="col-md-7 cursor-pointer"
                    v-on:click="
                      $router.push('/profile-view/' + data.from_user_id)
                    ">
                    <p
                      class="font-medium"
                      style="cursor: pointer; font-size: 18px">
                      {{ data.registration_no }}
                    </p>
                    <p
                      style="cursor: pointer"
                      :title="
                        getName(
                          data.first_name,
                          data.middle_name,
                          data.last_name
                        )
                      "
                      class="font-bold text-uppercase pink-clr">
                      {{
                        $helperService.getText(
                          getName(
                            data.first_name,
                            data.middle_name,
                            data.last_name
                          ),
                          150
                        )
                      }}
                    </p>
                    <div class="mr-user-details" style="gap: 0">
                      <div class="w-50">
                        <p class="font-14 text-uppercase">
                          {{
                            data.marital_status
                              ? data.marital_status.name
                              : "NA"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.dob
                              ? $helperService.getFormatedDate(data.dob)
                              : "NA"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.height
                              ? $helperService.getHeight(data.height)
                              : "NA"
                          }}
                        </p>
                        <p
                          :title="
                            data.education_courses ? data.education_courses : ''
                          "
                          class="font-14 font-semibold">
                          {{
                            data.education_courses
                              ? $helperService.getText(
                                  data.education_courses,
                                  40
                                )
                              : "NA"
                          }}
                        </p>
                      </div>
                      <div class="w-50">
                        <p class="font-14 font-light">
                          {{
                            data.occupation_details
                              ? data.occupation_details
                              : "NA"
                          }}
                        </p>
                        <p class="font-semibold">
                          {{
                            data.annual_income || data.annual_income == 0
                              ? $helperService.kFormatter(data.annual_income)
                              : "-"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.worK_place_name ? data.worK_place_name : "NA"
                          }}
                        </p>
                        <!-- <p class="font-14 font-semibold">
                          Native :
                          {{
                            data.native_place_district
                              ? data.native_place_district.name
                              : "NA"
                          }}
                        </p> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <ErrorComponent
            @retry="getProfileVisitorsList(0)"
            ref="getProfileVisitorsList" />
        </div>
        <!-- <div class="bg-light py-2" v-if="previousSearchCount > 0"></div> -->
        <!-- <div class="container pt-4" v-if="previousSearchCount > 0">
          <div class="row mb-3">
            <div class="col-md-6 col-8">
              <h3 class="font-bold font-22" v-if="previousSearchCount > 0">
                Previous Search ({{ previousSearchCount }})
              </h3>
            </div>
            <div class="col-md-6 col-4 text-md-end text-center">
              <a
                v-on:click="$router.push('/view-previous-search')"
                class="font-bold font-18"
                style="cursor: pointer"
                v-if="previousSearchCount > 4"
                >View All
              </a>
            </div>
          </div>
          <div class="row gy-4">
            <div
              class="col-lg-6"
              v-for="(data, index) in this.previousSearchList"
              :key="index"
              :value="data.uuid">
              <div
                v-if="index < 4"
                class="card card-body member-card mb-md-4 mb-3">
                <div class="row">
                  <div class="col-md-4 mb-md-0 mb-4 text-center">
                    <div
                      class="member-profile-photo cursor-pointer"
                      v-on:click="showUserGallery(data.user_images)">
                      <img
                        :src="data.image ? data.image : '/img/profile.svg'"
                        class="pro-pic" />
                      <span class="photos-count text-white"
                        ><i class="fa fa-camera" aria-hidden="true"></i>
                        <span class="ms-1">{{
                          data.user_images.length
                        }}</span></span
                      >
                    </div>
                    <button
                      v-if="data.hasSentIntrest == 0"
                      type="button"
                      class="btn btn-brand-1 mb-3 w-80"
                      :id="'sent_interest_' + index"
                      v-on:click="sendIntrest(data, index)">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send Interest
                    </button>
                    <button
                      v-if="data.hasSentIntrest == 1"
                      type="button"
                      class="btn btn-outline-brand-1"
                      :id="'cancel_interest_' + index"
                      v-on:click="notIntrested(data, index)">
                      <i class="fa fa-times" aria-hidden="true"></i>
                      Cancel Interest
                    </button>
                  </div>
                  <div
                    class="col-md-8 cursor-pointer"
                    v-on:click="$router.push('/profile-view/' + data.uuid)">
                    <p class="font-medium" style="cursor: ; font-size: 18px">
                      {{ data.registration_no }}
                    </p>
                    <p
                      :title="
                        getName(
                          data.first_name,
                          data.middle_name,
                          data.last_name
                        )
                      "
                      style="cursor: pointer"
                      class="font-bold text-uppercase pink-clr">
                      {{
                        $helperService.getText(
                          getName(
                            data.first_name,
                            data.middle_name,
                            data.last_name
                          ),
                          150
                        )
                      }}
                    </p>
                    <div class="mr-user-details">
                      <div class="">
                        <p class="font-14 text-uppercase">
                          {{
                            data.marital_status
                              ? data.marital_status.name
                              : "NA"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.dob
                              ? $helperService.getFormatedDate(data.dob)
                              : "NA"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.height
                              ? $helperService.getHeight(data.height)
                              : "NA"
                          }}
                        </p>
                        <p
                          :title="
                            data.education_courses ? data.education_courses : ''
                          "
                          class="font-14 font-semibold">
                          {{
                            data.education_courses
                              ? $helperService.getText(
                                  data.education_courses,
                                  40
                                )
                              : "NA"
                          }}
                        </p>
                      </div>
                      <div class="">
                        <p class="font-14 font-light">
                          {{
                            data.occupation_details
                              ? data.occupation_details
                              : "NA"
                          }}
                        </p>
                        <p class="font-semibold">
                          {{
                            data.annual_income || data.annual_income == 0
                              ? $helperService.kFormatter(data.annual_income)
                              : "-"
                          }}
                        </p>
                        <p class="font-14 font-semibold">
                          {{
                            data.working_place_taluka
                              ? data.working_place_taluka.name
                              : "NA"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </main>

    <TextModal ref="membershipPlan">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="form-group">
            <h4 class="text-center">Buy membership plan</h4>
          </div>
          <div class="text-center">
            <button
              class="btn btn-brand-1 btn-block"
              v-on:click="$refs.membershipPlan.closeModal()">
              Ok
            </button>
          </div>
        </div>
      </div>
    </TextModal>

    <TextModal ref="completeProfile">
      <div>
        <!-- <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div> -->
        <div class="modal-body pt-4 form-style">
          <div class="form-group">
            <h4 class="text-center">Please complete the profile</h4>
          </div>
          <div class="text-center">
            <button
              class="btn btn-brand-1 btn-block"
              v-on:click="closeModel2()">
              Ok
            </button>
          </div>
        </div>
      </div>
    </TextModal>

    <MainFooter />
    <ImageGalleryModel ref="galleryModel">
      <div
        class="modal-dialog photos-gallery modal-dialog-centered"
        style="max-width: 500px">
        <div class="modal-content">
          <div class="modal-header">
            <a
              class="close text-danger btn-pos"
              style="opacity: 1"
              v-on:click="$refs.galleryModel.closeModal()"
              type="button">
              <img
                src="/images/close-btn.png"
                width="25"
                height="25"
                style="background: #fff; border-radius: 100px" />
            </a>
          </div>
          <div class="modal-body">
            <div>
              <div class="text-center">
                <img
                  v-if="selected_image"
                  class="modal-box-img"
                  id="preview"
                  :src="selected_image"
                  width="600"
                  height="600" />
              </div>
            </div>
            <div class="image-gallary d-flex">
              <div
                class="col-2 me-2"
                v-for="(data, index) in detail.user_images"
                :key="index">
                <div v-if="data.image" v-on:click="changeImage(data.image)">
                  <img :src="data.image" width="50" height="50" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ImageGalleryModel>
  </div>
</template>
<script>
import TextModal from "@/components/TextModal.vue";
import ErrorComponent from "@/components/ErrorComponent";
import ImageGalleryModel from "@/components/ImageGalleryModel.vue";
export default {
  name: "UserDashboard",
  components: {
    ErrorComponent,
    ImageGalleryModel,
    TextModal,
  },
  data() {
    return {
      type: this.$route.params.type,
      loader: false,
      offset: -1,
      keyword: "",
      visitorsCount: "",
      membersCount: "",
      previousSearchCount: "",
      images: [],
      detail: {
        user_images: [],
      },
      selected_image: "",
      searchObj: {},
      myDetails: {},
      counts: {},
      newJoinedmemberlist: [],
      visitorslist: [],
      previousSearchList: [],
    };
  },
  mounted() {
    this.getMecall();
    this.getImages();
    this.getCounts();
    this.getNewJoinedMemberList(0);
    // this.getPreviousSearchList(0);
    this.getProfileVisitorsList(0);
    this.moveToContacat();
    window.scrollTo(-1000, -1000);
    document.getElementById('navbarSupportedContent').classList.remove('show');
  },
  methods: {
    moveToContacat() {
      window.scrollTo(-1000, -1000);
    },
    getImages() {
      this.$api
        .getAPI({
          _action: "/user/images",
        })
        .then((res) => {
          this.images = res.list;
        })
        .catch(() => {});
    },
    getMecall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.myDetails = res;
          var isProfileCompleted = localStorage.getItem("isProfileCompleted");
          if (!this.type && isProfileCompleted == null) {
            if (
              this.myDetails.is_membership_subscribed == "N" ||
              this.myDetails.is_membership_subscribed == null
            ) {
              this.$refs.membershipPlan.showModal();
            }
            if (
              this.myDetails.is_membership_subscribed == "Y" &&
              this.myDetails.profile_percentage != 100
            ) {
              this.$refs.completeProfile.showModal();
            }
          }
        })
        .catch(() => {});
    },
    closeModel2() {
      this.$refs.completeProfile.closeModal();
      localStorage.setItem("isProfileCompleted", true);
    },
    changeImage(image) {
      this.selected_image = "";
      this.selected_image = image;
      document.getElementById("preview").src = image;
    },
    closeModel() {
      this.detail.user_images = [];
      this.selected_image = "";
      this.$refs.galleryModel.closeModal();
    },
    showUserGallery(user_images) {
      if (user_images.length > 0) {
        this.selected_image = user_images[0].image;
        this.detail.user_images = user_images;
        this.$refs.galleryModel.showModal();
      }
    },
    getCounts() {
      this.$api
        .getAPI({
          _action: "/get-activity-count",
        })
        .then((res) => {
          this.counts = res;
        })
        .catch(() => {});
    },
    getProfileVisitorsList() {
      this.$refs.getProfileVisitorsList.updateListLoader(true);
      this.loader = true;
      this.visitorslist = [];

      this.$api
        .getAPI({
          _action: "/profile-visitors/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.visitorsCount = res.count;
          this.visitorslist = res.list;
          if (this.$refs.getProfileVisitorsList) {
            this.$refs.getProfileVisitorsList.setData(res, null);
            this.$refs.getProfileVisitorsList.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.getProfileVisitorsList) {
            this.$refs.getProfileVisitorsList.setData(0, undefined);
            this.$refs.getProfileVisitorsList.updateListLoader(false);
          }
        });
    },
    getPreviousSearchList() {
      this.$refs.getPreviousSearchList.updateListLoader(true);
      this.loader = true;
      this.previousSearchList = [];

      this.$api
        .getAPI({
          _action: "/previous-search/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.previousSearchCount = res.count;
          this.previousSearchList = res.list;

          if (this.$refs.getPreviousSearchList) {
            this.$refs.getPreviousSearchList.setData(res, null);
            this.$refs.getPreviousSearchList.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.getPreviousSearchList) {
            this.$refs.getPreviousSearchList.setData(0, undefined);
            this.$refs.getPreviousSearchList.updateListLoader(false);
          }
        });
    },
    getName(first, middle, last) {
      var name = "";
      if (first) {
        // name = first + " ";
      }
      if (middle) {
        // name = name + middle + " ";
      }
      if (last) {
        name = name + last;
      }
      return name;
    },
    getNewJoinedMemberList() {
      this.$refs.getNewJoinedMemberList.updateListLoader(true);
      this.loader = true;
      this.newJoinedmemberlist = [];

      this.$api
        .getAPI({
          _action: "/joined/member/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.membersCount = res.count;
          this.newJoinedmemberlist = res.list;

          if (this.$refs.getNewJoinedMemberList) {
            this.$refs.getNewJoinedMemberList.setData(res, null);
            this.$refs.getNewJoinedMemberList.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.getNewJoinedMemberList) {
            this.$refs.getNewJoinedMemberList.setData(0, undefined);
            this.$refs.getNewJoinedMemberList.updateListLoader(false);
          }
        });
    },
    sendIntrest(data, index) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
          _buttonId: "sent_interest_" + index,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getCounts();
          this.getNewJoinedMemberList();
          this.getPreviousSearchList();
          this.getProfileVisitorsList();
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    sendIntrestForVisitor(data, index) {
      var obj = {};
      obj.to_user_id = data.from_user_id ? data.from_user_id : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
          _buttonId: "sent_interest_" + index,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getCounts();
          this.getNewJoinedMemberList();
          this.getPreviousSearchList();
          this.getProfileVisitorsList();
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    notIntrestedForVisitor(data, index) {
      var $uuid = data.from_user_id ? data.from_user_id : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + $uuid,
          _buttonId: "cancel_interest_" + index,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getCounts();
          this.getNewJoinedMemberList();
          this.getPreviousSearchList();
          this.getProfileVisitorsList();
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    notIntrested(data, index) {
      var $uuid = data.uuid ? data.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + $uuid,
          _buttonId: "cancel_interest_" + index,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getCounts();
          this.getNewJoinedMemberList();
          this.getPreviousSearchList();
          this.getProfileVisitorsList();
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.profile-sider .carousel-control-prev {
  left: 50px;
  /* padding-top: 10px; */
  display: inline-block;
}
.profile-sider .carousel-control-next {
  right: 50px;
  /* padding-top: 10px; */
  display: inline-block;
}
</style>
